import type { FaireProductEntity } from "../../entity_types/product";

export const p_4cs4g26zb2: FaireProductEntity = {
  token: "p_4cs4g26zb2",
  type: "product",
  name: "LM-SW-1007 Light Pink/Grey Puff",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/8fee704e69001328af213fea3d4e36ee56145a738ea53c82dfcf18d1d562a8cb.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.5,
  description: "This Girlie Girl Originals graphic sweatshirt features a light pink and grey puff design that blends playful charm with casual wearability. Designed for women, it provides comfort and a stylish visual accent, making it a go-to piece for outings and laid-back looks.",
  tags: [],
  msrpDollars: 49,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:36.734Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
